// extracted by mini-css-extract-plugin
export default {"page":"tY-z","cartModal":"uY-z","checkout":"vY-z","placeholder":"wY-z","account":"xY-z"};